var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "instagram-share-13423_1_",
    "data-name": "instagram-share-13423 (1)",
    transform: "translate(0 -13.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11245",
    "data-name": "Path 11245",
    d: "M6.224,21.418a.6.6,0,0,1-.455-.208L.146,14.7a.6.6,0,0,1,.476-.988l16.8.589a.6.6,0,0,1,.26,1.126L6.505,21.348A.6.6,0,0,1,6.224,21.418ZM1.95,14.953l4.416,5.115,8.776-4.652Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11246",
    "data-name": "Path 11246",
    d: "M81.887,37.416a.615.615,0,0,1-.087-.006.6.6,0,0,1-.492-.434l-2.271-8.29a.6.6,0,0,1,.3-.686L90.51,22.075a.6.6,0,0,1,.791.845L82.4,37.135A.6.6,0,0,1,81.887,37.416Zm-1.566-8.585,1.783,6.51L89.1,24.179Z",
    transform: "translate(-73.392 -7.708)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramShare);
export default __webpack_public_path__ + "static/media/instagram_share.db2709049531970a5580c418e95c0a77.svg";
export { ForwardRef as ReactComponent };